var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"sideGuide",staticClass:"side-guide-container",style:({
    bottom: `${_vm.position.bottom}px`,
    right: `${_vm.position.right}px`,
  })},[_c('img',{staticClass:"customer-service",attrs:{"src":require("@/assets/images/customer-service.webp"),"alt":"客服","width":"100px","height":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }